import { Component, inject } from '@angular/core';
import { ListLayoutSingleComponent } from 'gung-list';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-top-product-list-layout',
  templateUrl: './top-product-list-layout.component.html',
  styleUrls: ['./top-product-list-layout.component.scss'],
  standalone: false
})
export class TopProductListLayoutComponent<T> extends ListLayoutSingleComponent<T> {
  private translateService = inject(TranslateService);

  getTitle(): string {
    return this.translateService.instant('TOP_PURCHASED_TITLE');
  }
}
